import { Box, Button, Checkbox, CircularProgress, IconButton, Typography } from "@mui/material";
import profileIcon from "../assets/images/profile2.svg";
import password from "../assets/images/password.svg";
import company from "../assets/images/company.svg";
import app from "../assets/images/app.svg";
import report from "../assets/images/report.svg";
import calendar from "../assets/images/calendar2.svg";
import access from "../assets/images/lock-access.svg";
import desktop from "../assets/images/desktop.svg";
import logout from "../assets/images/logouticon.svg";
import { useEffect, useState } from "react";
import LabeledTextField from "../mui-components/LabeledTextField";
import { useForm } from "react-hook-form";
import { aguserStore, configStore, loginStore, newDashboardState } from "../state/CommonState";
import { CheckBox, Visibility, VisibilityOff } from "@mui/icons-material";
import AguserApi from "../state/AguserApi";
import { AntSwitch } from "../mui-components/AntSwitch";
import { BlockedCheck } from "../mui-components/BlockedCheck";
import { CustomStyledTextField } from "../mui-components/ColoredTextfield";
import styled from "@emotion/styled";
import Agproducttab from "../components/Agproducttab";
import { bookingInformation } from "../StaticData";

let menus = [
    { title: "Profile", icon: profileIcon, component: <ProfilePage />, handler: () => { }, showSave: true },
    { title: "Password", icon: password, showSave: true, component: <ChangePassword /> },
    { title: "Entity", icon: company, showSave: true, component : <Entity/> },
    { title: "App Settings", icon: app, showSave: true, component: <AppSettings /> },
    // { title: "DSR Settings", icon: report, showSave: true, component : <DSRSettings/> },
    // { title: "DSR Scheduler", icon: calendar, showSave: true , component : <DSRScheduler/>},
    { title: "Access Control", icon: access, component: <AccessControlPage />, showSave: false }
]

function Menu({ isActive, item, onClick }) {
    return <Box onClick={() => {
        if (onClick) {
            onClick();
        }
    }} sx={{
        "&:hover": {
            cursor: "pointer"
        },
        fontFamily: "Figtree",
        textAlign: "start",
        wordBreak: "break-word",
        whiteSpace: "normal",
        padding: "5px",
        display: "flex",
        alignItems: "center",
        backgroundColor: isActive ? "#2A6ED4" : "white",
        width: "100%", borderRadius: "4px",
        color: isActive ? "white" : "#555555",
        "& img": {
            filter: isActive ? 'brightness(0) invert(1)' : "brightness(0) saturate(100%) invert(31%) sepia(4%) saturate(22%) hue-rotate(49deg) brightness(98%) contrast(85%)"
        },
    }}><img src={item.icon} /> <span style={{ paddingLeft: "8px" }}>{item.title}</span></Box>
}



function PasswordText({ control, name, rules, label, placeholder }) {
    const [show, showPassword] = useState(false)
    return <LabeledTextField labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} placeholder={placeholder} control={control} InputProps={{
        style: {
            // borderRadius:0
        },
        endAdornment: (
            <IconButton size="small" onClick={() => {
                showPassword((prevState) => !prevState);
            }}>
                {show ? <VisibilityOff /> : <Visibility />
                }                        </IconButton>
        ),
    }} type={show ? "text" : "password"} autoComplete="off" size="small" fullWidth label={label} name={name} rules={rules} />
}

function DeviceDetail({ iscurrentDevice = false, device, onLoggedOut }) {
    return <Box sx={{ display: "flex", flexDirection: "row", borderRadius: "7px", border: "1px solid #E8E8E8", padding: "10px", alignItems: "center", gap: 1 }}>
        <img width="25px" height="25px" src={desktop} />
        <Typography sx={{ fontFamily: "Figtree", marginRight: "auto" }}>{device.device}</Typography>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1, width: "150px" }}>
            <Box sx={{ height: "8px", width: "8px", borderRadius: "50%", backgroundColor: "#71A282" }}></Box>
            <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black" }}>Active</Typography>
        </Box>
        <Box sx={{ width: "100px" }}>
            {!iscurrentDevice && <Button onClick={() => {
                AguserApi.logout({ token: device.token, email: device.email }, (data) => {
                    if (onLoggedOut) {
                        onLoggedOut();
                    }
                });

            }} variant="contained" sx={{
                textTransform: "capitalize",
                height: "30px",
                borderRadius: "5px", backgroundColor: "#2B6ED4", "&:hover": {
                    backgroundColor: "#2B6ED4"
                }
            }} >Log Out</Button>}
        </Box>
    </Box>
}

function CenteredCircularProgress() {
    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}><CircularProgress /></Box>
}



function AccessControlPage() {
    const [currentDevice, setDevice] = useState();
    const [apiState, setApiState] = useState({ data: null, isLoading: true });
    const [disable, setDisable] = useState(false);
    const getList = () => {
        try {
            setApiState((prev) => ({ ...prev, isLoading: true }));
            AguserApi.devicelist((data) => {
                if (data && data?.length > 0) {
                    let currentToken = localStorage.getItem("devicetoken");
                    if (currentToken) {
                        let currentDevice = data.filter(({ token }) => token === currentToken);
                        setDevice(currentDevice[0]);
                        setApiState({ data: data.filter(({ token }) => token !== currentToken), isLoading: false });
                    }
                }
            })
        } catch (error) {
            setApiState((prev) => ({ ...prev, isLoading: false }));
            setDisable(false);
        }
    }

    useEffect(() => {
        getList();
    }, [])



    return <Box sx={{
        flex: 1, backgroundColor: "white", borderRadius: "10px", display: "flex", flexDirection: "column", padding: "10px", overflowY: "auto", "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#2A6ED4 !important"
        }
    }}>
        <Box sx={{ flex: 1, display: "flex", flex: 1, flexDirection: "column", gap: 3 }}>
            <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Access Control</Typography>
            {apiState.isLoading ? <CenteredCircularProgress /> : <>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }} >
                    <Typography sx={{ fontFamily: "Figtree", color: "black" }}>This Device:</Typography>
                    <DeviceDetail iscurrentDevice={true} device={currentDevice} />
                </Box>
                {apiState.data && apiState.data?.length > 0 && <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Typography sx={{ fontFamily: "Figtree", color: "black" }}>Other Devices:</Typography>
                    {apiState.data.map((device) => <DeviceDetail device={device} onLoggedOut={getList} />)}
                    <Button disabled={disable} onClick={() => {
                        let count = 0;
                        setDisable(true);
                        apiState.data.forEach((device) => {
                            AguserApi.logout({ token: device.token, email: device.email }, (data) => {
                                count++;
                                if (count === apiState.data?.length) {
                                    getList();
                                }
                            })
                        })
                    }} startIcon={<img src={logout} />} sx={{
                        alignSelf: "center", width: "30%", backgroundColor: "#F25B5B", borderRadius: "5px", color: "white", textTransform: "capitalize", "&:hover": {
                            backgroundColor: "#F25B5B"
                        }
                    }}>Log Out From Other Devices</Button>
                </Box>}
            </>}
        </Box>
    </Box>
}


function ChangePassword() {
    const defaultForm = useForm({
        defaultValues: {
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
        }
    });
    const { control, watch, handleSubmit } = defaultForm
    const password = watch('newPassword');


    const submitHandler = (data) => {
        AguserApi.setNewPassword(aguserStore.aguserRec._id, data.confirmPassword,
            (data) => configStore.setModalMessage('Password Changed! Please login again with new password.'))
        loginStore.reinitialize()
        localStorage.removeItem('ag_email')
        localStorage.removeItem('ag_userrec')
    }

    return <CommonSection formSubmit={handleSubmit(submitHandler)} buttonName="Change Password" formRef={defaultForm}><Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
        <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Change Password</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, padding: "14px" }}>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Box sx={{ width: "300px" }}>
                    <PasswordText rules={{ required: "Old Password is Required", validate: (value) => value === aguserStore.aguserRec.password || "Incorrect Password" }} control={control} name="oldPassword" label="Old Password" placeholder="Enter your old password" />
                </Box>
                <Box sx={{ width: "300px" }}>
                    <PasswordText rules={{ required: "New Password is Required" }} control={control} name="newPassword" label="New Password" placeholder="Enter your new password" />
                </Box>
                <Box sx={{ width: "300px" }}>
                    <PasswordText rules={{ required: "Confirm Password is Required", validate: (value) => value === password || 'The passwords do not match', }} control={control} name="confirmPassword" label="Confirm Password" placeholder="Enter your confirm password" />
                </Box>
            </Box>
        </Box>
    </Box>
    </CommonSection>
}


function Section({ component, buttonName, content }) {
    return <>
        <Box sx={{
            flex: 1, backgroundColor: "white", borderRadius: "10px", display: "flex", flexDirection: "column", padding: "10px", overflowY: "auto", "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#2A6ED4 !important"
            }
        }}>
            {component}
        </Box>
       <Box sx={{display:"flex",flexDirection:"row",height:"6%",justifyContent: content ? "space-between" : "end",alignItems:"center"}}>
        { content}
       <Box sx={{ display: "flex", flexDirection: "row", height: "100%", justifyContent: "end", gap: 2 }}>
            <Button onClick={() => {
                newDashboardState.selectedTab = 0;
                newDashboardState.isProfileSelected = false;
            }} size="small"
                // startIcon={<img style={{ width: "90%", height: "90%" }} src={prices} />} 
                sx={{ textTransform: "capitalize", backgroundColor: "white" }}>Cancel</Button>
            <Button type="submit" size="small"
                // startIcon={<img style={{ width: "90%", height: "90%" }} src={prices} />} 
                variant="contained" sx={{ textTransform: "capitalize" }}>{buttonName || "Save Changes"}</Button>
        </Box>
       </Box>
    </>
}


function SettingOptions({ option, label }) {
    return <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
        {option}
        <Typography sx={{ fontFamily: "Figtree", }}>{label}</Typography>
    </Box>
}

function IndividualSettings({ title, content }) {
    return <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <Typography sx={{ width: "280px", fontFamily: "Figtree", color: "black", fontSize: "14px" }}>{title}</Typography>
        <span style={{ paddingX: "10px" }}>:</span>
        <Box sx={{ display: "flex", flexDirection: "row", gap: 3 }}>{content}</Box>
    </Box>
}

function CommonSection({ formSubmit, children, buttonName, content }) {

    return <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", gap: 1 }}>
        {formSubmit ? <form onSubmit={formSubmit} style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", gap: 3 }}>
            <Section content={content} component={children} buttonName={buttonName} />
        </form> : <Section component={children} buttonName={buttonName} content={content} />
        }
    </Box>

}


function CustomSwitch({ isChecked = false }) {
    const [checked, setChecked] = useState(isChecked)
    return <AntSwitch onChange={(e) => {
        setChecked(e.target.checked);
    }} checked={checked} style={{ scale: "1" }} />
}

function DSRScheduler(){
    return <CommonSection>
         <Box sx={{ display: "flex", flex: 1, flexDirection: "column", gap: 3 }}>
         <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Scheduler</Typography>
         <IndividualSettings title="Daily Status Report Schedule Timing" content={ <CustomStyledTextField size="small" type="time" />} />
         <IndividualSettings title="Daily Status Report Scheduling Days" content={<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2,flexWrap:"wrap" }}>
                <SettingOptions option={<Checkbox  disableRipple  sx={CustomCheckBoxStyle} />} label="Monday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Tuesday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Wednesday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Thursday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Friday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Saturday" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Sunday" />
            </Box>} />
         </Box>
    </CommonSection>
}

const CustomCheckBoxStyle = {
    padding : 0,
    color : "#D4D4D4"
}

function AppSettings() {
    return <CommonSection>
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", gap: 3 }}>
            <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>App Settings</Typography>
            <IndividualSettings title="ReveChat on Dashboard" content={<SettingOptions option={<CustomSwitch />} label="On" />} />
            <IndividualSettings title="App Preferences" content={<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
                <SettingOptions option={<Checkbox  disableRipple  sx={CustomCheckBoxStyle} />} label="Cross Border" />
                <SettingOptions option={<Checkbox disableRipple sx={CustomCheckBoxStyle} />} label="Domestic Transport" />
            </Box>} />
            <IndividualSettings title="Communication Modes" content={<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
            <SettingOptions option={<BlockedCheck/>} label="Email" />

            </Box>} />
            <IndividualSettings title="Notification History" content={<SettingOptions option={<CustomSwitch />} label="On" />} />
        </Box>
    </CommonSection>
}


function ProfilePage() {
    const defaultForm = useForm({
        defaultValues: {
            firstName: aguserStore.aguserRec.firstName,
            lastName: aguserStore.aguserRec.lastName,
            email: aguserStore.aguserRec.email,
            phone: aguserStore.aguserRec.phone,
            password: "",
            confirmPassword: "",
            country: "",
            gst: "",
            role: aguserStore.aguserRec.role
        }
    });

    const { control, handleSubmit } = defaultForm;

    const submitHandler = (data) => {
        aguserStore.aguserRec.firstName = data.firstName;
        aguserStore.aguserRec.lastName = data.lastName;
        aguserStore.aguserRec.phone = data.phone;
        AguserApi.saveUser((data) => {
            aguserStore.aguserRec.set(data);
            let rememberMe = localStorage.getItem("ag_remember_user");
            let userRecString;
            let localUser;
            if (rememberMe === "true") {
                localUser = JSON.parse(localStorage.getItem("ag_userrec"))
            } else {
                localUser = JSON.parse(sessionStorage.getItem("ag_userrec"));
            }

            localUser.aguserRec = data;
            userRecString = JSON.stringify(localUser);
            if (rememberMe === "true") {
                localStorage.setItem("ag_userrec", userRecString)
            } else {
                sessionStorage.setItem("ag_userrec", userRecString);
            }
        });
    }

    return <CommonSection formSubmit={handleSubmit(submitHandler)}><Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
        <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Profile</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, padding: "14px" }}>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Box sx={{ width: "300px" }}>
                    <LabeledTextField rules={{ required: "First Name is required" }} labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} fontSize="14px" label="First Name" control={control} name="firstName" />
                </Box>
                <Box sx={{ flexBasis: "300px" }}>
                    <LabeledTextField labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} fontSize="14px" label="Last Name" control={control} name="lastName" />
                </Box>
                <Box sx={{ flexBasis: "300px" }}>
                    <LabeledTextField rules={{
                        required: "Phone Number is Required", pattern: {
                            value: /^[0-9]{10}$/,
                            message: `Invalid phone number`
                        }
                    }} labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} fontSize="14px" label="Phone Number" control={control} name="phone" />
                </Box>
            </Box>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Box sx={{ flexBasis: "300px" }}>
                    <LabeledTextField disabled={true} labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} fontSize="14px" label="Designation" control={control} name="role" />
                </Box>
                <Box sx={{ flexBasis: "300px" }}>
                    <LabeledTextField disabled={true} labelStyle={{ color: "black", fontFamily: "Figtree", fontSize: "14px" }} fontSize="14px" label="Email" control={control} name="email" />
                </Box>
                <Box sx={{ flexBasis: "300px" }}></Box>
            </Box>
        </Box>
    </Box>
    </CommonSection>
}

function Entity(){
    return <CommonSection>
        <Box sx={{display:"flex",flexDirection:"column",gap:2}}>
        <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Entity</Typography>
        </Box>
    </CommonSection>
}
        
function DsrSettingsList({title,list}){
         return <Box sx={{display:"flex",flexDirection:"column",gap:2}}>
             <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>{title} :</Typography>
             {list.map((option)=><SettingOptions option={option.mandatory ? <BlockedCheck/> : <CheckBox sx={CustomCheckBoxStyle}/> } label={option.milestone} />)} 
         </Box> 
}

function DSRSettings(){
    const [activeProduct, setActiveProduct] = useState("LCL");
    let productList = ['LCL', 'FCL', 'Air'];
    let stuffingList = ["Factory","CFS/Dock"];
    let [stuffingType,setStuffingType] = useState("Factory");
    let [deStuffingType,setDeStuffingType] = useState("Factory");
    return <CommonSection content={<Box sx={{display:"flex",flexDirection:"row",gap:1}}><span>*</span><BlockedCheck/><Typography sx={{fontFamily:"Figtree",color:"black",fontWeight:"bold"}}>Mandatory Field - Uncheckable</Typography></Box>}>
        <Box sx={{width:"20%"}}>
         <Agproducttab productList={productList} isGreyBackground={true}
                        activeProduct={activeProduct} setActiveProduct={setActiveProduct} />
                        </Box>
                        { activeProduct.toLowerCase()==="fcl" && <Box sx={{display:"flex",flexDirection:"row",marginY:"10px",gap:2}}>
                             <Box sx={{display:"flex",flexDirection:"column",width:"180px"}}>
                                <Typography sx={{fontFamily:"Figtree",color:"black"}}>Origin Stuffing</Typography>
                                <Box sx={{width:"100%"}}>
                                  <Agproducttab height="30px" isGreyBackground={true} productList={stuffingList} activeProduct={stuffingType} setActiveProduct={setStuffingType}      />
                                </Box>
                             </Box>
                             <Box sx={{display:"flex",flexDirection:"column",width:"180px"}}>
                                <Typography sx={{fontFamily:"Figtree",color:"black"}}>Destination De-Stuffing</Typography>
                                <Box sx={{width:"100%"}}>
                                  <Agproducttab height="30px" isGreyBackground={true} productList={stuffingList} activeProduct={deStuffingType} setActiveProduct={setDeStuffingType}      />
                                </Box>
                             </Box>
                            </Box>}
       <Typography sx={{ fontFamily: "Figtree", fontWeight: "bold", color: "black", fontSize: "18px" }}>Daily Status Report Milestones - {activeProduct.toUpperCase()}</Typography>
      <Box sx={{display:"flex",flexDirection:"row",width:"100%",padding:"20px 18px"}}>
        <Box sx={{display:"flex",flex:1}}>
            <DsrSettingsList title="Booking Information" list={bookingInformation}/>
        </Box>
        <Box sx={{display:"flex",flex:1}}>
            <DsrSettingsList title="Origin Milestones" list={bookingInformation}/>
        </Box>
        <Box sx={{display:"flex",flex:1}}>
            <DsrSettingsList title="In-transit Milestones" list={bookingInformation}/>
        </Box>
        <Box sx={{display:"flex",flex:1}}>
            <DsrSettingsList title="Destination Milestones" list={bookingInformation}/>
        </Box>
      </Box>
    </CommonSection>
}


export function SettingsPage() {
    const [selectedMenu, setMenu] = useState(0);
    useEffect(() => {
        return () => {
            newDashboardState.isProfileSelected = false;
            newDashboardState.selectedTab = 0;
        }
    }, [])
    return <Box sx={{ height: "100%", display: "flex", flexDirection: "row", width: "100%", gap: 1 }} >
        <Box sx={{ backgroundColor: "white", borderRadius: "10px", width: "180px", display: "flex", flexDirection: "column", gap: 1, padding: "12px" }}>
            {menus.map((menu, i) => <Menu onClick={() => {
                setMenu(i);
            }} isActive={selectedMenu === i} item={menu} />)}
        </Box>
        <Box sx={{ flex : 1, display: "flex", flexDirection: "column", gap: 1 }}>
            {/* <Box sx={{
                flex: 1, backgroundColor: "white", borderRadius: "10px", display: "flex", flexDirection: "column", padding: "10px", overflowY: "auto", "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#2A6ED4 !important"
                }
            }}> */}
            {menus[selectedMenu].component}
            {/* </Box> */}
            {/* {menus[selectedMenu].showSave && <Box sx={{ display: "flex", flexDirection: "row", width: "100%", height: "6%", justifyContent: "end", gap: 2 }}>
                <Button size="small"
                    // startIcon={<img style={{ width: "90%", height: "90%" }} src={prices} />} 
                    sx={{ textTransform: "capitalize", backgroundColor: "white" }}>Cancel</Button>
                <Button size="small"
                    // startIcon={<img style={{ width: "90%", height: "90%" }} src={prices} />} 
                    variant="contained" sx={{ textTransform: "capitalize" }}>Save Changes</Button>
            </Box>} */}
        </Box>
    </Box>
}